module.exports = __webpack_public_path__ + "static/landscape-maintenance.57bb3279.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/landscape-maintenance.jpg
// module id = 127
// module chunks = 35783957827783 93719862385932